import { API } from '@/api';
import axios from 'axios';

const state = {
};
const getters = {
};
const actions = {
  async getConceptoList({ commit, State }, {admin, condo, options}) {
    console.debug('IDss: %o', condo);
    const sortBy = options.sortBy[0] ? options.sortBy[0] + ',' + (options.sortDesc[0] ? 'desc' : 'asc') : '';
    const queryString = {page: options.page - 1, size: options.itemsPerPage, sort: sortBy};
    console.debug('queryString: %o', queryString);
    const response = await API.get('/conceptos/list/' + admin.id + '/' + condo.id, {params: queryString});
    return response.data;
  },
  async getConceptoListAll({ commit, State }, {admin, condo, options}) {
    console.debug('ID: %o', condo);
    const sortBy = options.sortBy[0] ? options.sortBy[0] + ',' + (options.sortDesc[0] ? 'desc' : 'asc') : '';
    const queryString = {page: options.page - 1, size: options.itemsPerPage, sort: sortBy};
    console.debug('queryString: %o', queryString);
    const response = await API.get('/conceptos/list/all/' + admin.id + '/' + condo.id, {params: queryString});
    return response.data;
  },
  getConceptoList1({ commit, State }, {datos}) {
    return API.get('/conceptos/list/' + datos.admin.id + '/' + datos.condo.id)
      .then((response) => response.data );
  },
  async getConceptoById({ commit, State }, {admin, condo, concepto}) {
    const response = await API.get('/conceptos/get/' + admin.id + '/' + condo.id + '/' + concepto.id);
    return response.data;
  },
  async getConceptoIngresoList({ commit, State }, {admin, condo, options}) {
  // async getConceptoIngresoList({ commit, State }, {admin, condo, options}) {
    // const sortBy = options.sortBy[0] ? options.sortBy[0] + ',' + (options.sortDesc[0] ? 'desc' : 'asc') : '';
    // const queryString = {page: options.page - 1, size: options.itemsPerPage, sort: sortBy};
    // const response = await API.get('/conceptos/list/ingresos/' + admin.id + '/' + condo.id, {params: queryString});
    const response = await API.get('/conceptos/list/ingresos/' + admin.id + '/' + condo.id);
    return response.data;
  },
  async getConceptoEgresoList({ commit, State }, {admin, condo, options}) {
    const sortBy = options.sortBy[0] ? options.sortBy[0] + ',' + (options.sortDesc[0] ? 'desc' : 'asc') : '';
    const queryString = {page: options.page - 1, size: options.itemsPerPage, sort: sortBy};
    const response = await API.get('/conceptos/list/egresos/' + admin.id + '/' + condo.id, {params: queryString});
    return response.data;
  },
  async addConcepto({ commit, State }, {datos}) {
    const response = await API.post('/conceptos/add/' + datos.admin.id + '/' + datos.condo.id, datos.concepto);
    return response.data;
  },
  async updateConcept({ commit, State}, {admin, condo, concept}) {
    const response = await API.post(`/conceptos/update/${admin.id}/${condo.id}`, concept);
    return response;
  },
  async deleteConcepto({ commit, State }, {condo, concepto}) {
    const response = await API.delete(`/conceptos/delete/${condo.id}/${concepto}`);
    return response.data;
  },
  async getImpuesto({ commit, State }, {admin, condo}) {
    const response = await API.get('/imp/list/' + admin.id + '/' + condo.id);
    return response.data;
  },
  async getUnidadMed({ commit, State }, {admin, condo}) {
    const response = await API.get('/unidadmed/list/' + admin.id + '/' + condo.id);
    return response.data;
  },
};
const mutations = {
};

export default {
  actions,
  getters,
  mutations,
  state,
};
